module.exports = __webpack_public_path__ + "img/rentBox-Y.197b60ca.png";